module.exports = __webpack_public_path__ + "static/media/java.652fdb65.png";